import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../../../backend/firebaseConfig"; 

const clean = (v) => (v ?? "").toString().trim();

const ALLOWED_TYPES = new Set(["info", "warning", "success", "error"]);

export async function writeCheck2Announcement({
  announcement,
  enabled,
  announcementType,
  updatedByEmail,
}) {
  const msg = clean(announcement);
  const type = clean(announcementType).toLowerCase();

  if (!ALLOWED_TYPES.has(type)) {
    throw new Error("Invalid announcement type");
  }

  // If enabled, require a message
  if (enabled && !msg) {
    throw new Error("Announcement message is required when enabled");
  }

  const ref = doc(db, "Compliance", "Check²");

  await setDoc(
    ref,
    {
      announcement: msg,
      enabled: !!enabled,
      announcementType: type,
      updatedAt: serverTimestamp(),
      updatedBy:
        auth.currentUser?.displayName ||
        auth.currentUser?.email ||
        "Unknown User",
    },
    { merge: true }
  );
}
